import React, { useState, useEffect } from "react";
import { Search } from "lucide-react";
import { api } from "../../lib/api";
import { Panel } from "../../lib/ui";
import { Input } from "../../components/ui/input";
import { Switch } from "../../components/ui/switch";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "../../components/ui/select";
import { Label } from "../../components/ui/label";
import { platformBadge, BUCKETS } from "./shared";

export default function PlatformCard({ platform, data, groups, onChange }) {
  const [custQ, setCustQ] = useState("");
  const [custRes, setCustRes] = useState([]);
  useEffect(() => {
    if (custQ.trim().length < 1) { setCustRes([]); return; }
    const t = setTimeout(() => api.get("/customers", { params: { q: custQ } }).then((r) => setCustRes(r.data.slice(0, 8))).catch(() => {}), 250);
    return () => clearTimeout(t);
  }, [custQ]);
  const set = (patch) => onChange({ ...data, ...patch });
  return (
    <Panel className="p-4 space-y-3" data-testid={`ak-card-${platform}`}>
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div className="font-semibold text-cocoa capitalize flex items-center gap-2">{platformBadge(platform)}</div>
        <div className="flex items-center gap-3 text-sm flex-wrap">
          <span className="text-cocoa/60">Auto Keep</span>
          <Switch checked={!!data.enabled} onCheckedChange={(v) => set({ enabled: v })} data-testid={`ak-enabled-${platform}`} />
          <span className="text-cocoa/60 ml-2">Auto Kasir</span>
          <Switch checked={!!data.cashier} onCheckedChange={(v) => set({ cashier: v })} data-testid={`ak-cashier-${platform}`} />
          <span className="text-cocoa/60 ml-2">Auto Cancel</span>
          <Switch checked={!!data.autocancel} onCheckedChange={(v) => set({ autocancel: v })} data-testid={`ak-autocancel-${platform}`} />
        </div>
      </div>
      <div>
        <Label className="text-cocoa text-xs">Customer Group</Label>
        <Select value={data.group_id || ""} onValueChange={(v) => set({ group_id: v, group_name: groups.find((g) => g.id === v)?.name || "" })}>
          <SelectTrigger className="bg-white" data-testid={`ak-group-${platform}`}><SelectValue placeholder="Pilih group" /></SelectTrigger>
          <SelectContent className="max-h-64">{groups.map((g) => <SelectItem key={g.id} value={g.id}>{g.name}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <div className="relative">
        <Label className="text-cocoa text-xs">Customer</Label>
        {data.customer_id
          ? <div className="flex items-center justify-between rounded-md border px-3 py-1.5 bg-white text-sm">
              <span>{data.customer_name}</span>
              <button className="text-xs text-red-600" onClick={() => set({ customer_id: "", customer_name: "" })} data-testid={`ak-cust-clear-${platform}`}>ganti</button>
            </div>
          : <>
              <Search className="w-4 h-4 absolute left-2 top-[30px] text-cocoa/40" />
              <Input className="pl-8 bg-white" placeholder="Cari customer (nama/HP)…" value={custQ} onChange={(e) => setCustQ(e.target.value)} data-testid={`ak-cust-search-${platform}`} />
              {custRes.length > 0 && (
                <div className="absolute z-10 mt-1 w-full bg-white border rounded-md shadow max-h-52 overflow-auto">
                  {custRes.map((c) => (
                    <button key={c.id} className="block w-full text-left px-3 py-1.5 text-sm hover:bg-ivory"
                      onClick={() => { set({ customer_id: c.id, customer_name: c.name }); setCustQ(""); setCustRes([]); }}
                      data-testid={`ak-cust-opt-${c.id}`}>{c.name} <span className="text-xs text-cocoa/50">{c.phone}</span></button>
                  ))}
                </div>
              )}
            </>}
      </div>
      <div>
        <Label className="text-cocoa text-xs">Alokasi Bucket / Gudang</Label>
        <Select value={data.sales_bucket || "HOME"} onValueChange={(v) => set({ sales_bucket: v })}>
          <SelectTrigger className="bg-white" data-testid={`ak-bucket-${platform}`}><SelectValue /></SelectTrigger>
          <SelectContent>{BUCKETS.map((b) => <SelectItem key={b} value={b}>{b}</SelectItem>)}</SelectContent>
        </Select>
        <p className="text-[11px] text-cocoa/50 mt-1">Produk ber-flag Pre Order selalu masuk PRE_ORDER. Gudang fisik mengikuti routing group.</p>
      </div>
    </Panel>
  );
}
